import React, { useEffect } from 'react';

import { getApplicableL2MyDataModules } from 'Deer/components/navigation/secondary/ModuleSection';
import { OrgPraisesIntent } from 'Deer/intent/Competencies/OrgPraisesIntent';
import { CompetenciesIntentDropdown } from 'Deer/intent/Competencies/components/CompetenciesIntentDropdown';
import { Layout } from 'Deer/intent/components/Layout/Layout';
import useOrganisationSettings from 'components/hooks/useOrganisationSettings';
import { useDispatch } from 'react-redux';
import { setSelectedView } from 'reducers/viewsSlice';
import { checkIntentLandingPagesFeatureEnabled } from 'utils/helpers/featureFlags';

interface Props {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  cohort: any;
}
const OrgPraises = ({ cohort }: Props) => {
  const dispatch = useDispatch();
  const { moduleName } = useOrganisationSettings();
  const applicableL2MyDataModules = getApplicableL2MyDataModules(moduleName) ?? [];

  useEffect(() => {
    dispatch(setSelectedView({ ...cohort, teamId: cohort.id }));
  }, [cohort, dispatch]);

  useEffect(
    () => () => {
      dispatch(setSelectedView({}));
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );

  if (checkIntentLandingPagesFeatureEnabled()) {
    return (
      <Layout
        Filters={
          <CompetenciesIntentDropdown
            breadcrumbs={{
              items: [
                {
                  label: 'Me',
                  to: applicableL2MyDataModules[0]?.value,
                },
              ],
              page: {
                label: 'Feedback',
                to: '',
              },
            }}
          />
        }
      >
        <OrgPraisesIntent />
      </Layout>
    );
  }

  return null;
};

export { OrgPraises };
